import React, { ReactNode } from 'react';
import { Components } from 'react-markdown/lib/ast-to-react';

export const MarkdownA: Components['a'] = ({ node, ...props }) => {
  const child = props.children.at(0);
  const href = props?.href || '#';
  let title: string | null|undefined |number|boolean |ReactNode= null;
  try {
    title = child !== href ? child : decodeURI(href);
  } catch (error) {
    title = child??href;
  }
  return <a {...props}>{title}</a>;
};
